import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04d7c03e&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=04d7c03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7c03e",
  null
  
)

export default component.exports